import { render } from "./FilterBlock.vue?vue&type=template&id=2550650e&scoped=true"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"

import "./FilterBlock.vue?vue&type=style&index=0&id=2550650e&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2550650e"]])

export default __exports__